import { OP } from "../../constant";

// view list
export function fetchStaffRequest(token, data) {
    return {
            type: OP.STAFF_LIST_REQUEST,
            payload: {
                token,
                data
            }
    }
}

export function fetchStaffReset() {
    return {
        type: OP.STAFF_LIST_RESET
    }
}

// add staff
export function addStaffRequest(token,data){
    return {
        type: OP.ADD_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function addStaffReset() {
    return {
        type: OP.ADD_STAFF_RESET
    }
}

// edit staff
export function editStaffRequest(token,data){
    return {
        type: OP.EDIT_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function editStaffReset() {
    return {
        type: OP.EDIT_STAFF_RESET
    }
}

// view staff
export function viewStaffRequest(token,data){
    return {
        type: OP.VIEW_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function viewStaffReset() {
    return {
        type: OP.VIEW_STAFF_RESET
    }
}

// activate staff
export function activateStaffRequest(token,data){
    return {
        type: OP.ACTIVATE_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function activateStaffReset() {
    return {
        type: OP.ACTIVATE_STAFF_RESET
    }
}

// deactivate staff
export function deactivateStaffRequest(token,data){
    return {
        type: OP.DEACTIVATE_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function deactivateStaffReset() {
    return {
        type: OP.DEACTIVATE_STAFF_RESET
    }
}

// approve Staff
export function approveStaffRequest(token, data) {
    return {
        type: OP.APPROVE_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function approveStaffReset() {
    return {
        type: OP.APPROVE_STAFF_RESET
    }
}

// reject Staff
export function rejectStaffRequest(token, data) {
    return {
        type: OP.REJECT_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function rejectStaffReset() {
    return {
        type: OP.REJECT_STAFF_RESET
    }
}

// reset Staff password
export function resetStaffPasswordRequest(token, data) {
    return {
        type: OP.RESET_STAFF_PASSWORD_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function resetStaffPasswordReset() {
    return {
        type: OP.RESET_STAFF_PASSWORD_RESET
    }
}

// unblock Staff 
export function unblockStaffRequest(token, data) {
    return {
        type: OP.UNBLOCK_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function unblockStaffReset() {
    return {
        type: OP.UNBLOCK_STAFF_RESET
    }
}
